import { sanitizeContent } from '@wconcept/wconcept-common/utils/htmlSanitizer';
import { isEmpty } from '../baseUtils';

const isSsr = (): boolean => typeof window === 'undefined';
export const setRecentResultList = async (
  keywordArr: string[],
  keyword?: string
) => {
  if (isEmpty(keywordArr)) {
    return;
  }

  // 최근 검색어 배열 길이 15개 제한
  if (keywordArr.length > 15) {
    keywordArr.pop();
  }

  // keyword 값 배열에서 삭제
  if (keyword) {
    for (let i = 0; i < keywordArr.length; i++) {
      if (keywordArr[i] === keyword) {
        keywordArr.splice(i, 1);
        i -= 1;
      }
    }
  }

  const date = new Date();
  // 30일 추가 30 * 24 * 60 * 60 * 1000
  date.setTime(date.getTime() + 2592000000);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('recentSearchKeyword', keywordArr.toString(), {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('recentSearchKeyword', keywordArr, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// 최근 검색어 불러오기. 추후 삭제

export const getRecentResultList = async () => {
  let recentSearchKeyword = '0';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    recentSearchKeyword = cookie.get('recentSearchKeyword')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    recentSearchKeyword = getCookie('recentSearchKeyword') as string;
  }
  if (isEmpty(recentSearchKeyword)) {
    recentSearchKeyword = '';
  }
  return recentSearchKeyword;
};

// 최근 검색어 전체 삭제. 추후 삭제

export const clearRecentSearchList = async () => {
  const date = new Date();
  date.setTime(date.getFullYear() - 30);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('recentSearchKeyword', '', {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('recentSearchKeyword', '', {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

export const deleteRecentCookie = async () => {
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.delete('wckRP');
  } else {
    const { deleteCookie } = await import('cookies-next');
    deleteCookie('recentSearchKeyword', {
      path: '/',
      domain: '.wconcept.co.kr',
    });
  }
};

// 최근 검색어 저장.

export const setWckRecentResultList = async (
  keywordArr: string[],
  keyword?: string
) => {
  if (isEmpty(keywordArr)) {
    return;
  }

  // 최근 검색어 배열 길이 15개 제한
  if (keywordArr.length > 15) {
    keywordArr.pop();
  }

  // keyword 값 배열에서 삭제
  if (keyword) {
    for (let i = 0; i < keywordArr.length; i++) {
      if (keywordArr[i] === keyword) {
        keywordArr.splice(i, 1);
        i -= 1;
      }
    }
  }

  const date = new Date();
  // 30일 추가 30 * 24 * 60 * 60 * 1000
  date.setTime(date.getTime() + 2592000000);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set(
      'wckRecentKeyword',
      keywordArr.slice(0, 10)?.reverse()?.join(','),
      {
        path: '/',
        domain: '.wconcept.co.kr',
        expires: date,
      }
    );
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie(
      'wckRecentKeyword',
      keywordArr.slice(0, 10)?.reverse()?.join(','),
      {
        path: '/',
        domain: '.wconcept.co.kr',
        expires: date,
      }
    );
  }
};

// 최근 검색어 불러오기.

export const getWckRecentResultList = async () => {
  let wckRecentKeyword = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckRecentKeyword = cookie.get('wckRecentKeyword')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckRecentKeyword = getCookie('wckRecentKeyword') as string;
  }
  if (isEmpty(wckRecentKeyword)) {
    return '';
  }
  return sanitizeContent(wckRecentKeyword)
    ?.split(',')
    ?.filter(item => !isEmpty(item))
    ?.reverse()
    ?.join();
};

// 최근 검색어 전체 삭제.

export const clearWckRecentSearchList = async () => {
  const date = new Date();
  date.setTime(date.getFullYear() - 30);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckRecentKeyword', '', {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckRecentKeyword', '', {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// 최근 검색한 검색어 저장
